import {Component, Input, OnInit} from '@angular/core';
import {MeasurementSlotDetailsComponent} from "../measurementslot-details/measurement-slot-details.component";
import {MeasurementDescriptionDataservice} from "../../measurements/MeasurementDescriptionDataservice";
import {MeasurementDescription, MeasurementDescriptionList} from "../../measurements/MeasurementDescriptionList";
import {interval, Subscription} from "rxjs";
import {MeasurementsDataService} from "../../measurements/MeasurementsDataService";
import {MeasurementData, MeasurementDataList} from "../../measurements/MeasurementDataList";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-measurement-list',
  templateUrl: './measurement-slot-list.component.html',
  styleUrls: ['./measurement-slot-list.component.css']
})
export class MeasurementSlotListComponent implements OnInit {
  @Input()
  private measurementDataList: MeasurementDataList | undefined;
  private measurementDescriptionList: MeasurementDescriptionList | undefined;
  private updateSubscription: Subscription | undefined;
  private componentList = Array<MeasurementSlotDetailsComponent>();

  counter(i: number) {
    return new Array(i);
  }

   constructor(private measurementDescriptionDataservice: MeasurementDescriptionDataservice,
               private measurementsDataService: MeasurementsDataService  ){
   }

  InlayOut(): void {
    this.measurementDescriptionDataservice.GetData().subscribe(
      {
        next: measurementDescriptionList => {
          this.measurementDescriptionList = measurementDescriptionList;
        }
      });
  }

  UpdateData(): void {
    this.measurementsDataService.GetData().subscribe(
      {
        next: measurementDataList => {
          this.measurementDataList = measurementDataList;
          this.componentList.forEach((detail => {
            detail.UpdateData(this.GetData(detail.slotNumber));
            detail.UpdateDescription(this.GetDescription(detail.GetFullChannel()));
          }))
        }
      });
  }


  ngOnInit(): void {
     this.InlayOut();
     this.updateSubscription = interval(environment.interval).subscribe(
       () => {
         this.UpdateData();
       }
     );
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  Add(measurementDetailsComponent: MeasurementSlotDetailsComponent): void {
    this.componentList.push(measurementDetailsComponent);
  }

  GetDescription(fullChannel: number): MeasurementDescription {
    if ((this.measurementDescriptionList) && (this.measurementDescriptionList.MeasurementDescription[fullChannel]))
      return this.measurementDescriptionList.MeasurementDescription[fullChannel];
    return new MeasurementDescription();
  }


  GetData(slotNumber: number): MeasurementData {

    if ((this.measurementDataList) && (this.measurementDataList.MeasurementData[slotNumber]))
    {
      if( this.measurementDataList.MeasurementData[slotNumber].number != slotNumber)
          console.warn("Slotnumber is not the expected one");
      return this.measurementDataList.MeasurementData[slotNumber];
    }
    return new MeasurementData();
  }

}
